// extracted by mini-css-extract-plugin
export default {"textSmallXs":"ConnectedReceivers_textSmallXs__qhDf9","cardShell":"ConnectedReceivers_cardShell__D-yfv","messageShell":"ConnectedReceivers_messageShell__j0Nki"};